import { render } from "./ErrorsPoppup.vue?vue&type=template&id=f36a6540"
import script from "./ErrorsPoppup.vue?vue&type=script&lang=js"
export * from "./ErrorsPoppup.vue?vue&type=script&lang=js"

import "./ErrorsPoppup.vue?vue&type=style&index=0&id=f36a6540&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__